import React, { useState, useContext, useEffect } from 'react'
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { ObjModal } from '../../../../contexts';


const Lookup = ( { label, db, related, aid, uid, contacts, loans, opps, tasks, formId = 'gen' } ) => {
    const { oid, objType } = useContext( ObjModal );
    const [ v, setV ] = useState( '' );
    
    useEffect( () => {
        if ( db ) {
            const [ lookup, field ] = db.split( '.' );

            switch ( objType ) {
                case 'loan':
                    const l = loans[oid];
                    if ( l ) {
                        if ( !related ) {
                            const refId = l[lookup];
                            if ( refId ) {
                                const c = contacts[refId];
                                if ( c ) {
                                    setV( c[field] );
                                }
                            }
                        } else {
                            switch ( related ) {
                                case 'leadopp':
                                    Object.keys( opps ).forEach( loid => {
                                        const o = opps[loid];
                                        if ( o && o.relationships ) {
                                            const lor = o.relationships.find( f => f.lid === l.lid );
                                            if ( lor ) {
                                                setV( o[field] );
                                            }
                                        }
                                    } );
                                    break;

                                default:
                                    console.log( 'Unknown related type on lookup field: ', db, related );
                            }
                        }
                    }
                    break;

                case 'contact':
                    const c = contacts[oid];
                    if ( c ) {
                        const refId = c[lookup];
                        if ( refId ) {
                            const r = contacts[refId];
                            if ( r ) {
                                setV( r[field] );
                            }
                        }
                    }
                    break;

                case 'task':
                    const t = tasks[oid];
                    if ( !related ) {
                        if ( t ) {
                            const refId = t[lookup];
                            if ( refId ) {
                                const r = contacts[refId];
                                if ( r ) {
                                    setV( r[field] );
                                }
                            }
                        }
                    } else {
                        switch ( related ) {
                            case 'loan':
                                const ta = ( t && t.assoc && t.assoc.length ) ? t.assoc.find( f => f.lid ) : null;
                                if ( ta ) {
                                    const l = loans[ta.lid];
                                    if ( l ) {
                                        setV( l[field] );
                                    }
                                }
                                break;

                            default:
                                console.log( 'Unknown related type on lookup field: ', db, related );
                        }
                    }
                    // console.log( 'Task lookup: ', t );
                    break;

                default:
                    console.log( 'Unknown objType for lookup: ' + objType );
            }
        }
    }, [ db, contacts, loans, opps, tasks, related, oid, objType ] );

    return (
        <Col className='tf-obj-data-element align-items-center'>
            <Form.Group as={Row} className='tf-form-group' controlId={`${formId}-${db}`}>
                <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>{label}</Form.Label>
                <Col className='tf-form-text-field me-1'>
                    <Row className='align-items-center'>
                        <Col>
                            {v}
                        </Col>
                    </Row>
                </Col>
            </Form.Group>
        </Col>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    opps: state.leadopps.byId,
    tasks: state.tasks.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Lookup );